import '../../styles/gradient-spinner.css';

import React from 'react';
import { Box, Image, Text, useColorModeValue } from '@chakra-ui/react';

import boltImg from '../../assets/images/evse_charger_loader_bolt.svg';

type BoltLoaderProps = {
  description?: string;
  testId?: string;
};

export const BoltLoader = ({ description, testId }: BoltLoaderProps) => {
  const gradientColorModeClassName = useColorModeValue('light-mode-gradient', 'dark-mode-gradient');

  return (
    <Box
      position="fixed"
      inset={0}
      bg="#111111"
      opacity={0.7}
      zIndex="overlay"
      display="flex"
      alignItems="center"
      justifyContent="center"
      data-testid={testId}
    >
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <Box position="relative" h="120px" w="120px">
          <Box className={`gradient-spinner ${gradientColorModeClassName}`} />
          <Image
            src={boltImg}
            alt="EV Charger Power On"
            position="absolute"
            top="50%"
            left="50%"
            transform="translate(-50%, -50%)"
          />
        </Box>
        {description ? (
          <Text mt={4} color="white" textAlign="center" maxW="165px">
            {description}
          </Text>
        ) : null}
      </Box>
    </Box>
  );
};
